// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3j978","requiredAsterisk":"Info_requiredAsterisk__lqMaN"};